module.exports = __webpack_public_path__ + "media/images/landing/crime/kidnap-9a7a7fd5f424544ccca35ef9d0df5666.png";